import List from 'src/storage/list';

export class BaseContactModel extends List {
  id = 'BaseContactModel';
  refreshOnInit = true;
  refreshOnSubscribe = false;
  persistent = false;
  idKey = 'partnerId';
  sortBy = {
    key: 'posted',
    desc: true
  };
  defaultState = () => ({
    active: '',
    current: 'recent',
    tabs: {
      main_treatment: 'treatment',
      main_message: 'chat'
    },
    isOpenBookAppointment: false,
    images: []
  });
  apiConfig = {
    refresh: {
      url: 'contact/refresh',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'contact_refresh'
    },
    list: {
      url: 'contact/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'contact/search',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    accounts: {
      url: 'account/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      }
    }
  };
  _events = {
    profile: 'handleProfile',
    // contact_refresh: 'onContactRefresh',

    updateContact: 'handleUpdateContact',
    'foxsocket:message:contact_update': 'handleUpdateContactWS',
    'foxsocket:message:contact_blocked_create': 'contactBlockCreated',
    'foxsocket:message:contact_blocked_remove': 'contactBlockRemoved',
    calling: 'onCalling'
  };
  listParams(loadMore) {
    let req = {
      skip: 0,
      limit: this.listLimit,
      archive: false
    };
    let query = this.input('search') || this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }
  handleProfile = (profile) => {
    this.setState({ profile, user: profile });
  };

  mapItem = (item) => {
    if (!item.partnerAvatarUrls) {
      const user = { id: item.partnerId, gender: item.partnerGender };
      item.partnerAvatarUrls = this.makeUserAvatar(user, item.partnerAvatar, this.imageSizes.user);
    }
    item.unread = item.users[0]._id === this.userId ? item.users[0].unread : item.users[1].unread;
    return item;
  };

  handleUpdateContactWS = ({ data }) => {
    // if (channel !== 'u-' + this.userId) return;
    this.handleUpdateContact({
      partnerId: data.partnerId,
      data: data
    });
  };

  handleUpdateContact = ({ partnerId, data }) => {
    this.items('recent').map((item) => {
      if (item.partnerId === partnerId) {
        Object.keys(data).map((key) => {
          if (key !== 'key' && key !== 'value') {
            item[key] = data[key];
            if (key === 'partnerAvatar' || key === 'partnerId' || key === 'partnerGender') {
              item.partnerAvatarUrls = this.makeUserAvatar(
                { id: item.partnerId, gender: item.partnerGender },
                item.partnerAvatar,
                this.imageSizes.user
              );
            }
          }
        });
        this.log('handleUpdateContact updated');
        this.trigger();
        this.save();
      }
    });
  };

  contactBlockCreated = ({ data }) => {
    if (data.userId !== this.user.id) {
      return;
    }

    this.items('recent').map((t) => {
      if (t.partnerId === data.blockedId) {
        t.blocked = data.created;
      }
    });
    this.items('search').map((t) => {
      if (t.partnerId === data.blockedId) {
        t.blocked = data.created;
      }
    });
    this.log('handleUpdateContact updated');
    this.trigger();
    this.save();
  };

  contactBlockRemoved = ({ data }) => {
    if (data.userId !== this.user.id) {
      return;
    }

    this.items('recent').map((t) => {
      if (t.partnerId === data.blockedId) {
        delete t.blocked;
      }
    });
    this.items('search').map((t) => {
      if (t.partnerId === data.blockedId) {
        delete t.blocked;
      }
    });
    this.log('handleUpdateContact updated');
    this.trigger();
    this.save();
  };

  loadSelected = (accountIds, cb) => {
    if (accountIds.length === 0) return cb(false, []);
    this.api('accounts', { accountIds, limit: 1000, skip: 0 }, cb);
  };
}

const model = new BaseContactModel();
export default model;
